import React from 'react'
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs'
import SideNav from '../../Components/SideNav'
import styles from "./Styles/BOQ.module.css"
import common from "./Styles/Common.module.css"
import {BiChevronRight} from "react-icons/bi"
import { useNavigate } from 'react-router-dom'

export default function BOQ() {
  const navigate = useNavigate()
  return (
    <div className={common.container}>
        <div className={common.backIcon}>
            <div onClick={()=>navigate('/dashboard/leads')}>
                <BsChevronLeft size={26} color="#0E1123" />
            </div>
            <p>Back</p>
        </div>

        <main>
            <SideNav />

            <div className={common.main}>
                
          <table cellPadding={0} cellSpacing={0} className={styles.table}>
            <thead>
              <tr>
                <th>Concept</th>
                <th>Cost</th>
                <th>Status</th>
                <th width="50px"></th>
              </tr>
            </thead>
            <tbody>
              {Array(3).fill('').map(i => {
                return <tr>
                <td>Paraxis Old</td>
                <td>₹4,000</td>
                <td><p className={styles.created}>Created</p></td>
                <td><BiChevronRight color="#299EFE" size={22} /></td>
              </tr>
              })}
            </tbody>
          </table>

         </div>
        </main>
    </div>
  )
}
